
import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faBullseye,
  faFlag,
  faHandshake,
  faLightbulb,
  faShieldAlt,
  faStar
} from '@fortawesome/free-solid-svg-icons';
import { setupRevealAnimations } from './revealAnimations';
import ceoImage from './public/images/CEO OF AL-RAHIM GROUP OF COMPANIES.jpg';
import './About.css';

const coreValues = [
  { title: 'Integrity', icon: faShieldAlt, desc: 'We uphold uncompromising ethical standards across all operations.' },
  { title: 'Reliability', icon: faStar, desc: 'We deliver on our commitments with precision and consistency.' },
  { title: 'Nation-Building', icon: faFlag, desc: 'We create opportunities for millions through skills development, employment, and economic mobility.' },
  { title: 'Innovation', icon: faLightbulb, desc: 'We embrace technology and global best practices to modernize systems and processes.' },
  { title: 'Excellence', icon: faStar, desc: 'We strive to provide superior service across all business units.' },
  { title: 'Collaboration', icon: faHandshake, desc: 'We work closely with governments, global partners, and industries to build sustainable and long-term impact.' }
];

const About = () => {
  useEffect(() => {
    setupRevealAnimations();
    return () => {
      window.removeEventListener('scroll', setupRevealAnimations);
    };
  }, []);

  return (
    <div className="about-container">
      <div className="about-main-content">

{/* Ceo Chairmans section */}
<section className="about-section about-ceo-section reveal-card">
          <div className="about-ceo-image-wrap">
            <img src={ceoImage} alt="CEO of Al-Rahim Group of Companies" className="about-ceo-image" />
            <div className="about-ceo-badge">
              <span>Leadership</span>
              <strong>SYED SHUJAAT ALI</strong>
              <span>Al-Rahim Group</span>

            </div>
          </div>
          <div className="about-ceo-content">
            <span className="about-kicker">Chairman OF AL-RAHIM GROUP OF COMPANIES</span>
            <h2>Visionary Leadership, Lasting Impact</h2>
            <p className="about-ceo-content-text">
              Under the guidance of our Chairman, Al-Rahim Group continues to expand with a clear focus on innovation, integrity, and national progress. The Chairman&apos;s leadership combines strategic global thinking with practical local execution to strengthen every business vertical.
            </p>
            <p className="about-ceo-content-text">
              By championing modern systems, transparent governance, and people-centered development, the Chairman has built a culture where performance and trust grow together. This direction empowers the Group to create high-value opportunities for industry partners, professionals, and communities across Pakistan.
            </p>
          </div>
        </section>


     



        <section className="about-pillars">
          <article className="about-section about-mission reveal-card">
            <h2>
              <FontAwesomeIcon icon={faBullseye} />
              Our Mission
            </h2>
            <ul>
              <li><FontAwesomeIcon icon={faArrowRight} />Efficient and reliable logistics services</li>
              <li><FontAwesomeIcon icon={faArrowRight} />Development of modern terminals and infrastructure</li>
              <li><FontAwesomeIcon icon={faArrowRight} />Creation of a globally skilled workforce</li>
              <li><FontAwesomeIcon icon={faArrowRight} />Implementation of advanced training systems</li>
              <li><FontAwesomeIcon icon={faArrowRight} />Strategic international collaborations</li>
              <li><FontAwesomeIcon icon={faArrowRight} />High-trust business models and financial protection frameworks</li>
            </ul>
          </article>

          <article className="about-section about-vision reveal-card">
            <h2>
              <FontAwesomeIcon icon={faFlag} />
              Our Vision
            </h2>
            <p>
              To become Pakistan’s leading multi-sector enterprise, transforming national logistics, workforce competitiveness, and global trade integration through innovation, infrastructure, and international partnerships.
            </p>
          </article>
        </section>

        <section className="about-section about-core-values reveal-card">
          <h2>Our Core Values</h2>
          <div className="core-values-grid">
            {coreValues.map((val, idx) => (
              <div className="core-value-card" key={val.title} style={{ animationDelay: `${idx * 0.08}s` }}>
                <span className="core-value-icon">
                  <FontAwesomeIcon icon={val.icon} />
                </span>
                <div>
                  <h4>{val.title}</h4>
                  <p>{val.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="about-section about-hero reveal-card">
          <span className="about-kicker">Al Rahim Group</span>
          <h1>About Us</h1>
          <p>
            Al-Rahim Group of Companies is a dynamic and forward-thinking conglomerate shaping the future of Pakistan’s logistics, workforce, education, and industrial ecosystem. With over a decade of operational excellence and a diversified multi-industry portfolio, the Group has earned a strong reputation for integrity, reliability, and strategic execution.
            Our unique strength lies in seamlessly integrating physical infrastructure, human capital development, digital systems, financial protection, and international connectivity. This unified approach enables us to deliver scalable, end-to-end solutions unmatched by any private enterprise in Pakistan.
            From pioneering Pakistan’s first One Window Overseas Employment Facilitation Platform to developing modern off-dock container terminals, launching internationally recognized training pathways, and forming high-value global partnerships, Al-Rahim Group remains deeply committed to nation-building.
            We continue to expand rapidly, driving transformative impact across both public and private sectors through innovation, technology adoption, and global-standard professional practices.
          </p>
        </section>

      </div>
    </div>
  );
};

export default About;
